import getStaticFile from '@helpers/bucket';

const LIGHT_THEME_PATH = 'icons/lightTheme/helpcenter';

const HEADER_DESKTOP = {
  src: getStaticFile({ path: LIGHT_THEME_PATH, fileName: 'header-desktop.svg' }),
  height: 140,
  width: 1366,
};

export const HelpCenterHeaderDesktop = {
  alt: 'Help Center',
  light: HEADER_DESKTOP,
  blackFriday: HEADER_DESKTOP,
  dark: HEADER_DESKTOP,
};

const HEADER_MOBILE = {
  src: getStaticFile({ path: LIGHT_THEME_PATH, fileName: 'header-mobile.svg' }),
  height: 140,
  width: 360,
};

export const HelpCenterHeaderMobile = {
  alt: 'Help Center',
  light: HEADER_MOBILE,
  blackFriday: HEADER_MOBILE,
  dark: HEADER_MOBILE,
};

const FOOTER_DESKTOP = {
  src: getStaticFile({ path: LIGHT_THEME_PATH, fileName: 'footer-desktop.svg' }),
  height: 76,
  width: 2000,
};

export const HelpCenterFooter = {
  alt: 'Help Center',
  light: FOOTER_DESKTOP,
  blackFriday: FOOTER_DESKTOP,
  dark: FOOTER_DESKTOP,
};

// export default HelpCenter;
